import { permissions } from "@/store/permissionsStore";

class Can {
  constructor(modifier, permisionOrRole) {
    this.modifier = modifier;
    this.permisionOrRole = permisionOrRole;
  }

  hasRole(userRole) {
    const storePermission = permissions();
    const roles = storePermission.getRolesSystem;
    const rolesUser = storePermission.getRoles;

    let nivel = 10000; // não mexe aqui, nao precisa
    for (const rule of rolesUser) {
      let index = roles.indexOf(rule);
      if (index < nivel) nivel = index;
    }

    const nivelDoPapelDoElemento = roles.indexOf(userRole);

    const nivelDoMaiorPapelDoUsuario = roles.indexOf(roles[nivel]);

    if (nivelDoMaiorPapelDoUsuario <= nivelDoPapelDoElemento) {
      return true;
    }
    return false;
  }

  hasRoleByArray(roles) {
    for (const role of roles) {
      if (this.hasRole(role)) return true;
    }
    return false;
  }

  hasPermission(userPermissions = "") {
    const storePermission = permissions();
    const [permission, escopo] = userPermissions.split("#");

    if (
      storePermission.getPermissions &&
      storePermission.getPermissions[permission]
    ) {
      return storePermission.getPermissions[permission].includes(escopo);
    }
    return false;
  }

  hasPermissionByArray(arrayPermission) {
    for (const permision of arrayPermission) {
      if (this.hasPermission(permision)) return true;
    }
    return false;
  }

  role(roles) {
    if (typeof roles == "string") return this.hasRole(roles);
    return this.hasRoleByArray(roles);
  }

  permission(permissions) {
    if (typeof permissions == "string") return this.hasPermission(permissions);
    return this.hasPermissionByArray(permissions);
  }

  isAllowed() {
    if (!this.permisionOrRole) return true;
    return this[this.modifier](this.permisionOrRole);
  }
}

const canDirective = {
  inserted(el, binding) {
    const modifierPermited = ["role", "permission"];

    if (binding.arg == undefined) {
      throw 'arg is required, use v-can: [${modifierPermited.join(" or ")}]';
    }
    if (!modifierPermited.includes(binding.arg)) {
      throw 'arg [${ binding.arg  }] not found, use v-can: [${modifierPermited.join(" or ")}]';
    }

    const can = new Can(binding.arg, binding.value);
    const allowed = can.isAllowed();

    if (!allowed && el.parentNode !== null) {
      el.parentNode.removeChild(el);
    }
  },
};

export default {
  install(Vue) {
    Vue.directive("can", canDirective);
  },
};
